function dm_hash(){
    console.log('>> dm_hash', window.location.hash);

    // Delay initial hash scroll until GSAP/ScrollTrigger has refreshed so hidden/revealed content reports correct positions.
    (function handleInitialHash(){
        if (!window.location.hash) return;
        const hash = window.location.hash.replace('#','');
        const $target = $('section[data-slug="' + hash + '"]');
        if (!$target.length) return;

        const doScroll = () => {
            try {
                const top = Math.round($target.offset().top);
                // account for fixed header offset (adjust if needed)
                window.scrollTo({ top: top - 84, left: 0, behavior: 'auto' });
                console.log('dm_hash scrolled to', hash, top);
            } catch (err) {
                console.error('dm_hash scroll failed', err);
            }
        };

        // If ScrollTrigger exists, refresh it then wait a frame+short timeout to ensure layout finished
        if (window.gsap && window.ScrollTrigger) {
            try {
                ScrollTrigger.refresh(); // force recalculation
            } catch (e) { /* ignore */ }
            requestAnimationFrame(() => setTimeout(doScroll, 160));
        } else {
            // fallback small delay for stability on slower machines
            requestAnimationFrame(() => setTimeout(doScroll, 60));
        }
    })();

    // HASH CLICKS
    $('section a').on('click', function(e) {
        var $link = $(this).attr('href');
        if ($link && $link.includes('#') && $(this).hasClass('no-hash-scroll') === false ) {
            var tempLink = document.createElement('a');
            tempLink.href = $link;
            if (tempLink.pathname === window.location.pathname && tempLink.hostname === window.location.hostname) {
                var $hash = $link.substring($link.indexOf('#') + 1);
                let $target = $('section[data-slug="' + $hash + '"]');
                if ( $target.length ) {
                    $('html,body').animate({ scrollTop: $target.offset().top - 50 }, 0, 'linear');
                }
            }
        }
    });
}

export { dm_hash };